import type { EditSelectOptionList } from 'components/forms/EditSelect';

import type { IntervalRecurrenceUnit } from './EditableRecurrence';

/**
 * All 7 interval units the backend accepts, in natural time-magnitude order.
 * (`window_open` is the separate radio mode, not an interval unit.)
 *
 * Shared by every interval-unit dropdown — the recurrence-definition editor and
 * the ad-hoc rule on the submit screen — so the two cannot drift apart.
 */
export const INTERVAL_UNIT_OPTIONS: EditSelectOptionList<IntervalRecurrenceUnit> = [
  { key: 'second', value: 'second', label: 'Seconds' },
  { key: 'minute', value: 'minute', label: 'Minutes' },
  { key: 'hour', value: 'hour', label: 'Hours' },
  { key: 'day', value: 'day', label: 'Days' },
  { key: 'week', value: 'week', label: 'Weeks' },
  { key: 'month', value: 'month', label: 'Months' },
  { key: 'year', value: 'year', label: 'Years' },
];
